module.exports = __webpack_public_path__ + "img/fiche-aero-fev14.eb203b08.gif";